import { proxy } from 'comlink';
import { createWorker } from '../../utils/workerUtils';
import { AbstractVideoEngine } from './AbstractVideoEngine';
import { VideoFrameExtractor } from './VideoFrameExtractor';
export class ChromeVideoEngine extends AbstractVideoEngine {
    LOG_PREFIX = '[ChromeVideoEngine]';
    videoFrameExtractors = new Map();
    constructor() {
        super();
        console.log(`${this.LOG_PREFIX} constructor called`);
    }
    async onDestroy() {
        for (const videoFrameExtractor of this.videoFrameExtractors.values()) {
            await videoFrameExtractor.stop();
        }
        this.videoFrameExtractors.clear();
    }
    async addMediaStreamVideoTrack(track) {
        console.log(`${this.LOG_PREFIX} addMediaStreamVideoTrack called`, {
            trackId: track.id,
        });
        const videoFrameExtractor = new VideoFrameExtractor(track);
        videoFrameExtractor.emitter.on('aborted', () => {
            console.log(`${this.LOG_PREFIX} videoFrameExtractor aborted, cleaning up track`, { trackId: track.id });
            this.videoFrameExtractors.delete(track.id);
            console.log(`${this.LOG_PREFIX} track removed from main thread, remaining tracks: ${this.videoFrameExtractors.size}`, { trackId: track.id });
        });
        this.videoFrameExtractors.set(track.id, videoFrameExtractor);
        console.log(`${this.LOG_PREFIX} adding unencoded video track to worker, total tracks: ${this.videoFrameExtractors.size}`);
        await this.workerProxy?.addUnencodedVideoTrack(proxy(videoFrameExtractor.getOutputTrack()));
        console.log(`${this.LOG_PREFIX} starting videoFrameExtractor`);
        await videoFrameExtractor.start();
        console.log(`${this.LOG_PREFIX} addMediaStreamVideoTrack completed`, {
            trackId: track.id,
        });
    }
    async removeMediaStreamVideoTrack(track) {
        console.log(`${this.LOG_PREFIX} removeMediaStreamVideoTrack called`, {
            trackId: track.id,
        });
        // this will trigger the worker to remove the track
        this.videoFrameExtractors.get(track.id)?.stop();
        console.log(`${this.LOG_PREFIX} removeMediaStreamVideoTrack completed`, {
            trackId: track.id,
        });
    }
    getWorkerFileName() {
        return 'ChromeVideoEngineWorker';
    }
    createWorker() {
        // Not DRY, but otherwise webpack won't transform the worker url
        if (import.meta.env.BUILD_TRANSFORMS_FILENAMES) {
            console.log(`${this.LOG_PREFIX} creating worker with URL constructor`);
            return new Worker(new URL('./ChromeVideoEngineWorker.ts', import.meta.url), { type: 'module' });
        }
        console.log(`${this.LOG_PREFIX} creating worker with createWorker util`);
        // Use .ts extension for Vite dev server, .js for production
        const ext = import.meta.env.DEV ? '.ts' : '.js';
        return createWorker(`./ChromeVideoEngineWorker${ext}`, import.meta.url);
    }
}
